import {
  Flex,
  HStack,
  Icon,
  Image,
  Stack,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiStore2Line } from "@remixicon/react";
import {
  DetailTransactionsInterface,
  FooterTransaction,
} from "../../constants/Transaction";
import formatNumber, { formatToRupiah } from "../../utils/helperFunction";
import { AddResiModal } from "../dashboard_supplier/AddResiModal";
import { TrackOrderModal } from "../dashboard_supplier/TrackOrderModal";

interface Props extends StackProps {
  orderId: any;
  data: DetailTransactionsInterface | undefined;
  footer: FooterTransaction | undefined;
  pageType: number;
}

export const ProductTransactionCard = ({
  orderId,
  data,
  pageType,
  footer,
  ...rest
}: Props) => {
  return (
    <VStack
      className="product-transaction-card"
      w={"100%"}
      align={"stretch"}
      mb={pageType === 2 ? undefined : [2, 4, 6]}
      {...rest}
    >
      <HStack mt={2} mb={2}>
        <Icon as={RiStore2Line} />
        <Text textStyle={"b-reg-sb"}>{data?.store}</Text>
      </HStack>

      {data?.products &&
        data?.products.map((product, i) => (
          <Stack
            className="item-card"
            key={i}
            w={"100%"}
            direction={["column", "column", "row", "row", "row"]}
            mb={2}
            alignItems={"start"}
            justify={"space-between"}
          >
            <HStack
              w={"100%"}
              flex={1}
              className="wrap-left"
              alignItems={"start"}
            >
              <Image
                className="ratio-1-1"
                src={
                  product.image
                    ? `${process.env.REACT_APP_MEDIA_URL}${product.image}`
                    : ""
                }
                alt={product.name || "Image Product"}
                fallbackSrc="/assets/svg/illustration_empty.svg"
                maxW={["60px", "80px", null, "80px"]}
                objectFit={"cover"}
                borderRadius={"md"}
              />

              <VStack align={"stretch"} gap={0}>
                <Text textStyle={"b-reg-sb"}>{product.name}</Text>

                <HStack mt={1}>
                  <Text textStyle={"b-sm"} variant={"secondary"}>
                    {`${formatNumber(product.quantity)} x`}
                  </Text>

                  <Text textStyle={"b-sm"} variant={"secondary"}>
                    {`Rp ${formatNumber(product.price)}`}
                  </Text>
                </HStack>

                {product.variant && (
                  <VStack align={"stretch"}>
                    <Text textStyle={"b-sm"} variant={"secondary"}>
                      {`Varian: ${product.variant}`}
                    </Text>
                  </VStack>
                )}

                {product.reseller_name && (
                  <Text
                    textStyle={"b-sm"}
                    variant={"secondary"}
                  >{`Reseller : ${product.reseller_name}`}</Text>
                )}
              </VStack>
            </HStack>

            {product.total && data.expedition_price && (
              <VStack className="wrap-right" align={"stretch"} gap={0}>
                <Text textStyle={"b-sm"} fontWeight={"300"}>
                  Total Harga
                </Text>

                <Text textStyle={"b-reg-sb"} whiteSpace={"nowrap"}>
                  {formatToRupiah(product.total)}
                </Text>
              </VStack>
            )}
          </Stack>
        ))}

      {pageType !== 2 && (
        <VStack w={"100%"} align={"stretch"}>
          <HStack alignItems={"start"}>
            <Flex flex={1}>
              <Text textStyle={"b-reg"}>Ongkos Kirim</Text>
            </Flex>

            <Flex flex={3}>
              <Text textStyle={"b-reg"}>{`: ${
                data?.expedition_price &&
                formatToRupiah(parseInt(data?.expedition_price.toString()))
              }`}</Text>
            </Flex>
          </HStack>

          <HStack alignItems={"start"}>
            <Flex flex={1}>
              <Text textStyle={"b-reg"}>Kurir</Text>
            </Flex>

            <Flex flex={3}>
              <Text
                textStyle={"b-reg"}
                style={{ textTransform: "uppercase" }}
              >{`: ${data?.expedition}`}</Text>
            </Flex>
          </HStack>

          <HStack alignItems={"start"}>
            <Flex flex={1}>
              <Text textStyle={"b-reg"}>Nomor Resi</Text>
            </Flex>

            <Flex flex={3}>
              <Text textStyle={"b-reg"}>{`: ${
                data?.resi ? data.resi : "Belum tersedia"
              }`}</Text>
            </Flex>
          </HStack>

          {!data?.resi && pageType === 3 && (
            <AddResiModal id={orderId} w={"fit-content"} mt={4} />
          )}

          {pageType !== 3 && data?.resi && (
            <TrackOrderModal
              id={orderId}
              pageType={pageType}
              resi={data.resi}
              w={"fit-content"}
            />
          )}
        </VStack>
      )}
    </VStack>
  );
};
